import styled from 'styled-components'

import BaseNotificationDot from './BaseNotificationDot'

const UnfilledNotificationDot = styled(BaseNotificationDot)`
  border: 1px solid ${({ theme }) => theme.palette.neutral.default.five};
`

export default UnfilledNotificationDot
